import TableContainer from "pages/Properties/roles/TableComponent";
import { useEffect, useState } from "react";
import {  Badge, Button, Dropdown, DropdownItem, DropdownMenu, DropdownToggle, Input, Label, Modal, ModalBody,  ModalHeader } from "reactstrap";
import SimpleBar from "simplebar-react";
import { isJson } from "utils";
import { DropdownActions } from "../Actions/DropdownActions";

const ViewAll = ({ show, onCloseClick, viewlist, setisDeleteOpen, setIsEditOpen, setRecord, props, setViewId, setView, view, setFields, model, onChange}: any) => {
   const onHandleselect = (item: any) => {
    if(item?.fields && isJson(item?.fields)) {
        setFields(JSON.parse(item?.fields))
    }
   }

   const onEdit = (item: any) =>  {
    setIsEditOpen(true);
    setRecord(item);
    onCloseClick() 

}

const onDuplicate = (item: any) =>  {
    let fields  =  item?.fields && isJson(item?.fields) ? JSON.parse(item?.fields) : item?.fields
    onChange(fields, `${item.name} copy`)
}


const onActivate = (item: any) =>  {
    setViewId(item?.id);
    setView(item);
    onHandleselect(item);
    onCloseClick()
}

const extraActions = [{
    clickHandler: onEdit,
    btn_type: "btn-soft-secondary",
    btn_icon: "ri-pencil-fill",
    btn_name: props.t(`users.edit`),
    action: 'edit',
    module: model
    },{
    clickHandler: onDuplicate,
    btn_type: "btn-soft-info",
    btn_icon: "ri-file-copy-fill",
    btn_name: props.t(`users.duplicate`),
    action: 'create',
    module: model
    },
    {
    clickHandler: onActivate,
    btn_type: "btn-soft-success",
    btn_icon: "ri-checkbox-circle-line",
    btn_name: props.t(`users.activate`),
    conditionalField: 'id',
    conditionalFieldValue: view?.id,
    hidePermission: true,
    skipPermission:true
    }
    ]

    const defaultExtraActions = [
        {
        clickHandler: onActivate,
        btn_type: "btn-soft-success",
        btn_icon: "ri-checkbox-circle-line",
        btn_name: props.t(`users.activate`),
        conditionalField: 'id',
        conditionalFieldValue: view?.id,
        hidePermission: true,
        skipPermission:true
        }
    ]
    return (
        <Modal backdrop="static" isOpen={show} toggle={onCloseClick} centered={true} size="xl">
            <ModalHeader className="p-3 offcanvas-header-dark d-flex flex-row justify-content-between align-items-center bg-primary" toggle={onCloseClick}>
                <span className='text-light'>{props.t('common.modals.all_about_views')}</span>
            </ModalHeader>
            <ModalBody className='text-center p-5'>
            <div className="table-responsive">
                <SimpleBar autoHide={false} className="simplebar-track-dark pe-2" style={{ maxHeight: "500px" }}>
                    <table className="table align-middle position-relative table-nowrap">
                        <thead className="cursor-pointer table-active position-sticky">
                            <tr>
                                <th className="border-bottom-1 table-soft-primary  fw-bold" style={ {textAlign:'left' }}>
                                    View Name
                                </th>
                                <th  className="border-bottom-1 table-soft-primary  fw-bold">
                                    Location
                                </th>
                                <th  className="border-bottom-1 table-soft-primary  fw-bold">
                                    Actions
                                </th>
                            </tr>
                        </thead>

                        <tbody id="task-list">
                            {viewlist?.length ? viewlist.map((item: any, key: any) => (
                                <tr key={key} style={{ verticalAlign: 'middle', maxHeight: 50 }}>
                                    <td style={{ verticalAlign: 'middle', textAlign:'left' }} className='align-items-center justify-content-between'>
                                        <div>
                                            <div>
                                                {item.name}{" "}{view?.id ===item?.id ? <Badge color="success">Currently Active</Badge> : "" }
                                            </div>
                                        </div>
                                    </td>
                                    <td style={{ verticalAlign: 'middle' }} className='align-items-center justify-content-between'>
                                        <div>
                                            <div>
                                                {item.location}
                                            </div>
                                        </div>
                                    </td>

                                    <td style={{ verticalAlign: 'middle' }} className='d-flex align-items-center justify-content-center'>
                                            <DropdownActions
                                                row={{original: item}}
                                                permissions={item?.permissions}
                                                extraActions={item?.id  === 'zaDefaultAbout' ? defaultExtraActions : extraActions}
                                                handleLeadClick={setRecord}
                                                setIsDeleteOpen={setisDeleteOpen}  
                                                translater={props.t}
                                                module={model}
                                                actionArray={item?.id  === 'zaDefaultAbout' ? [''] : ['delete']}
                                            />
                                    </td>
                                </tr>))
                                : null}
                        </tbody>
                    </table>                    
                    {viewlist?.length ? null : <div className="text-center w-100 fs-16 fw-semibold">{props.t("common.table.no_views_to_show")}</div>}
                </SimpleBar>
            </div>

            </ModalBody>
        </Modal>
    ) as unknown as JSX.Element;
};

export default ViewAll;